import React from 'react';
import { graphql } from 'gatsby';
import { FormattedMessage } from 'react-intl';
import { Heading } from '@printdeal/ui-library';
import Content from '../widgets/Content';
import { LinkedFaq } from '../../types/helpCenter/helpCenter';

interface IHelpCenterLinkedFaq {
  linkedFaq: LinkedFaq[];
}

/** @knipignore */
export const query = graphql`
  fragment LinkedFaq on ContentfulSupportFaq {
    id: contentful_id
    title
    content {
      content
    }
  }
`;

const HelpCenterLinkedFaq = ({ linkedFaq }: IHelpCenterLinkedFaq) => (
  <>
    <Heading variant="display" size="2">
      <FormattedMessage
        id="helpcenter.support.faq.title"
        defaultMessage="Frequently Asked Questions"
      />
    </Heading>
    {linkedFaq.map((linkedEntry) => (
      <Content
        key={linkedEntry.id}
        title={linkedEntry.title}
        content={linkedEntry?.content}
      />
    ))}
  </>
);

export default HelpCenterLinkedFaq;
